<!-- <template>
  <footer class="m0 pa3">
    <w-flex> -->
    <!-- <span class="box">&copy; 2021 - {{ new Date().getFullYear() }} 2en Apps Sdn Bhd</span> -->
    <!-- <span class="spacer"></span>
    <div class="box">
    <w-button @click="scrollToTop" icon="fal fa-angle-double-up">
    </w-button>
    </div>
    </w-flex>
  </footer>
</template> -->

<template>
  <footer class="floating-footer">
    <w-flex>
      <span class="spacer"></span>
      <div class="box">
        <w-button 
          @click="scrollToTop" 
          icon="fal fa-angle-double-up"
        />
      </div>
    </w-flex>
  </footer>
</template>

<script>
export default {
  methods: { 
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    }
  }
}
</script>

<style scoped>

.floating-footer {
  position: fixed;
  bottom: 10px;
  right: 10px;
  z-index: 9999;
  background: transparent;
  padding: 0;
  margin: 0;
}

</style>